// styles.js
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
pageWrapper: {
    display: "flex",
    minHeight: "100vh",
    backgroundImage: "url('/30495.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
},


  contentWrapper: {
    width: "100%",
    flexGrow: 1,

    boxSizing: "border-box",
  },
  
   "@media (max-width:768px)": {
    contentWrapper: {
    paddingBottom: "56px",
    },
  },
  
  contentWithSideMenu: {
    marginLeft: "200px",
    transition: "margin-left 0.3s ease-in-out",
  },
});

